import * as React from 'react'

import { Table } from '@factorialco/deprecated-design-system'
import {
  TimesheetPageShiftFragment,
  TimesheetReviewsStatsFragment,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import BulkChange from 'modules/attendance/components/ClockIn/Shifts/DailyShifts/DailyTable/BulkChange'
import type Store from 'modules/attendance/components/ClockIn/Store'

import PeriodStatus from '../PeriodStatus'

interface Props {
  store: Store
  submitBulkChange: (shifts: TimesheetPageShiftFragment[]) => void
  shifts: TimesheetPageShiftFragment[]
  reviewsStats: TimesheetReviewsStatsFragment | null
}

const Head = ({ store, reviewsStats, submitBulkChange, shifts }: Props) => {
  return (
    <Table.Head>
      <Table.Row>
        <Table.HeadCell colSpan={3}>
          <PeriodStatus reviewsStats={reviewsStats} />
        </Table.HeadCell>
        <Table.HeadCell>
          <BulkChange shifts={shifts} store={store} submitBulkChange={submitBulkChange} />
        </Table.HeadCell>
      </Table.Row>
      <Table.Row>
        <Table.HeadCell>{i18n.t('clock_in.bulk_action.days')}</Table.HeadCell>
        <Table.HeadCell>{i18n.t('clock_in.bulk_action.worked_shifts')}</Table.HeadCell>
        <Table.HeadCell colSpan={2}> </Table.HeadCell>
      </Table.Row>
    </Table.Head>
  )
}

export default Head
